import { create } from "zustand";

export type AppPhase = 'loading' | 'preshake' | 'shaking' | 'postshake' | "reset";

export type TransitionState = {
  onContinue: () => void;
  onCancel: () => void;
  cancelText?: string;
  continueText?: string;
  message?: string;
} | null;

type UiStoreState = {
  phase: AppPhase;
  setPhase: (phase: AppPhase) => void;
  transition: TransitionState;
  openTransition: (transition: TransitionState) => void;
  closeTransition: () => void;
};

export const useUiStore = create<UiStoreState>((set) => ({
  phase: 'preshake',
  setPhase: (phase) => set({ phase }),
  transition: null,
  openTransition: (transition) => set({ transition }),
  closeTransition: () => set({ transition: null }),
}));
